const PuzzleModelEvent = {};
export default PuzzleModelEvent;

PuzzleModelEvent.STATUS = "PuzzleModelEvent.STATUS";
PuzzleModelEvent.MOVE = "PuzzleModelEvent.MOVE";
PuzzleModelEvent.ELAPSED_TIME = "PuzzleModelEvent.ELAPSED_TIME";
PuzzleModelEvent.MOVE_INVALID = "PuzzleModelEvent.MOVE_FAILED";